module.exports = __webpack_public_path__ + "img/aliment.b7393f8d.jpg";